"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePrepareExerciseData = void 0;
const usePrepareExerciseData = (data) => {
    const result = data.reduce((acc, row) => {
        var _a, _b, _c;
        return acc
            .concat((_a = row.additional_correct_words) !== null && _a !== void 0 ? _a : [])
            .concat((_b = row.additional_words) !== null && _b !== void 0 ? _b : [])
            .concat((_c = row.right_word) !== null && _c !== void 0 ? _c : [])
            .filter(Boolean)
            .map(word => String(word).replace(/(?!['’-])\p{P}/gu, "").trim().toLowerCase());
    }, []);
    return { wordList: [...new Set(result)] };
};
exports.usePrepareExerciseData = usePrepareExerciseData;
